import {ISO_DATE_FORMAT} from '../../../util/date';

import {
    LocalPackFilterQueriesType,
    LocalPackFilterType,
    LocalPackFilterUrlQueryNameEnum,
} from './local-pack-filter/local-pack-filter-type';

export function getLocalPackFilterValues(filter: LocalPackFilterType): LocalPackFilterQueriesType {
    // dayjs formats in the local time zone, so the picked calendar day is sent as is, without a UTC shift
    return {
        [LocalPackFilterUrlQueryNameEnum.startDate]: filter.timeRange[0]?.format(ISO_DATE_FORMAT) ?? '',
        [LocalPackFilterUrlQueryNameEnum.endDate]: filter.timeRange[1]?.format(ISO_DATE_FORMAT) ?? '',
        [LocalPackFilterUrlQueryNameEnum.searchQueries]: filter.searchQueries.join(','),
    };
}
